var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.952,
    height: 23.952,
    viewBox: "0 0 23.952 23.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(-370.292 -946.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropright-circle",
    "data-name": "Icon ionic-ios-arrow-dropright-circle",
    d: "M3.375,15.351A11.976,11.976,0,1,0,15.351,3.375,11.974,11.974,0,0,0,3.375,15.351Zm14.078,0-4.716-4.67A1.111,1.111,0,0,1,14.309,9.11L19.8,14.62a1.11,1.11,0,0,1,.035,1.532l-5.412,5.43a1.109,1.109,0,1,1-1.572-1.566Z",
    transform: "translate(366.917 943.28)",
    fill: "#62cfd0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.6d25b9e1165a00d661fa9d1bcd9d3dbf.svg";
export { ForwardRef as ReactComponent };